import React from 'react';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { AiOutlineCloseCircle } from 'react-icons/ai';

import { FaRegEye } from 'react-icons/fa';
import { getTimeAgo } from '../../../_helpers/getTimeAgo';

const RedeemAmountIndividualCard = ({
  accountName = "Huzaifa Khan",
  accountNumber = "4242424242424242",
  ifscCode,
  bankName = "YES BANK",
  accountType = "Savings",
  branch = "Jaipur",
  accountCurrency = "INR",
  swiftCode,
  statusTitle,
  updatedStatusDate,
  showOkay,
  handleApprove,
  handleReject,
  handleMoreInfo,
  verifiedBy,
  handleAction,
  userId,
  fees,
  summary,
  amountInCurrency,
  notes,
  requestStatus,
  allData

}) => {





  const renderIconsAndText = () => {
    switch (statusTitle) {
      case 'Pending':
        return (
          <div className="flex gap-1">
            <div className="flex items-center justify-center w-5 h-5">
              <button className='cursor-pointer' onClick={handleReject}>
                <AiOutlineCloseCircle className="text-[22px] text-[#F6465D]" title='Reject' />
              </button>
            </div>
            <div className="flex items-center justify-center w-5 h-5">
              <button onClick={handleApprove}>
                <IoMdCheckmarkCircleOutline className="text-[22px] text-[#02BC7D]" title='Approve' />
              </button>
            </div>
            {/* <div className="flex items-center justify-center w-5 h-5">
              <button onClick={handleMoreInfo}>
                <LuRefreshCcw className="text-[22px] text-[#FFA600]" title='More-Info' />
              </button>
            </div> */}
          </div>
        );
      case 'Approved':
        return (
          <div>
            <span className="text-md font-[500] text-[#F6465D]">By ({verifiedBy?.userName || "N/A"} , {verifiedBy?.employeeId || "N/A"})</span>
          </div>
        );
      case 'Declined':
        return (
          <div>
            <span className="text-md font-[500] text-[#F6465D]">By ({verifiedBy?.userName || "N/A"} , {verifiedBy?.employeeId || "N/A"})</span>
          </div>
        );
      case 'more-info':
        return (
          <div>
            <span className="text-md font-[500] text-[#F6465D]">By ({verifiedBy?.userName || "N/A"} , {verifiedBy?.employeeId || "N/A"})</span>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <>
      <div className="flex items-center justify-between p-4 border-[1px] border-[#D2D2D2] rounded-xl">
        <div className="flex items-center gap-2">
          <span className="font-medium text-[#F6465D]">{statusTitle}</span>
          {renderIconsAndText()}
          {
            ((notes && notes.length > 0) || allData?.attachment) && (
              <button onClick={() => handleAction(allData)}>
                <FaRegEye className="text-[22px] text-blue-500 hover:text-blue-700 transition-colors" title='View Details' />
              </button>
            )
          }

        </div>
        <span className="text-sm text-[#F6465D] font-[500]">{getTimeAgo(allData.updatedAt)}</span>
      </div>
      <div className="flex flex-col w-full mx-auto overflow-hidden border border-gray-200 rounded-lg shadow-sm md:flex-row">
        <div className="w-full p-6 bg-white border-b border-gray-200 md:border-b-0 md:border-r">
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">User Name:</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{userId?.name}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">User Email:</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{userId?.email}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Account Name :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{accountName}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Account Number :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{accountNumber}</span>
            </div>

            {
              ifscCode && (
                <div className="flex justify-between">
                  <span className="text-[#0F172AB2] font-[500] text-[14px]">IFSC Code :</span>
                  <span className="text-[#0F172AB2] font-[500] text-[14px]">{ifscCode}</span>
                </div>
              )
            }
            {
              swiftCode && (
                <div className="flex justify-between">
                  <span className="text-[#0F172AB2] font-[500] text-[14px]">Swift code :</span>
                  <span className="text-[#0F172AB2] font-[500] text-[14px]">{swiftCode}</span>
                </div>
              )
            }


            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Bank Name :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{bankName}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Account Type :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{accountType}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Branch :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{branch}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Account Currency :</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{accountCurrency}</span>
            </div>



          </div>
        </div>


        <div className="w-full p-6 bg-white">
          {showOkay && (
            <div className='flex justify-between mb-6'>
              <span className='text-[#000000] text-[16px] font-[500]'>
                Confirmation Number : 3587415
              </span>
              <span>
                <button className='bg-[#F6465D] text-[#FFFFFF] font-[500] text-[14px] rounded-md p-2 w-20 cursor-pointer'>
                  Okay
                </button>
              </span>
            </div>
          )}
          <div className="space-y-3">
            {/* User Info */}


            {/* Fees */}
            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Total Redeem Amount:</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{summary?.totalRedeemAmount}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Redeem Fees:</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{fees?.redeemFees}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Knowledge Fees:</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{fees?.knowledgeFees}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Innovation Fees:</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{fees?.innovationFees}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Total Fees:</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{fees?.totalFees}</span>
            </div>

            {/* Summary */}
            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Rate:</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{summary?.rate}</span>
            </div>

            <div className="flex justify-between">
              <span className="text-[#0F172AB2] font-[500] text-[14px]">Amount in Currency:</span>
              <span className="text-[#0F172AB2] font-[500] text-[14px]">{(amountInCurrency ?? 0).toFixed(4)}</span>
            </div>

            {allData?.attachment && (
              <div className="flex justify-between items-center pt-2 border-t border-gray-100">
                <span className="text-[#0F172AB2] font-[500] text-[14px]">Proof Attachment:</span>
                <div className="flex items-center gap-2">
                  <img
                    src={allData.attachment}
                    alt="Proof"
                    className="w-10 h-10 object-cover rounded border border-gray-200 cursor-pointer hover:opacity-80 transition-opacity"
                    onClick={() => handleAction(allData)}
                    title="Click to view full preview"
                  />
                  <button
                    type="button"
                    onClick={() => handleAction(allData)}
                    className="text-xs text-blue-600 hover:text-blue-800 underline font-medium"
                  >
                    View Proof
                  </button>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </>
  );
};

export default RedeemAmountIndividualCard;